/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { OffersPageProps, OffersStep } from 'legacy/events/offers.types';
import React, { useState } from 'react';
import CreateOfferPage from './CreateOfferPage';
import OfferDetailPage from './OfferDetailPage';
import OfferListMVP from './OfferListMVP';

export const offersStepMap = {
  [OffersStep.CREATE_OFFER]: CreateOfferPage,
  [OffersStep.OFFERS_LIST]: OfferListMVP,
  [OffersStep.EDIT_OFFER]: CreateOfferPage,
  [OffersStep.OFFER_DETAILS]: OfferDetailPage
};

const OffersPage = (props: OffersPageProps) => {
  const { step } = props;
  const [offerId, _] = useState<string>(undefined);

  // const handleOfferClick = (offerId: string) => {
  //   setOfferId(offerId);
  //   setOffersStep(OffersStep.OFFER_DETAILS);
  // };

  const OffersStepComponent = offersStepMap[step];
  return (
    <OffersStepComponent
      // handleOfferClick={handleOfferClick}
      offerId={offerId}
      {...props}
    />
  );
};

export default OffersPage;
